// components/forms/Checkbox.tsx
import { useAppTheme } from "@/hooks/useAppTheme";
import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";

export interface CheckboxProps {
  label: string;
  value: boolean;
  onValueChange: (newValue: boolean) => void;
  error?: string;
  disabled?: boolean;
  containerStyle?: object;
  labelStyle?: object;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  value,
  onValueChange,
  error,
  disabled = false,
  containerStyle,
  labelStyle,
}) => {
  const { colors, spacing, borderRadius, typography } = useAppTheme();

  const handlePress = () => {
    if (!disabled) {
      onValueChange(!value);
    }
  };

  const styles = StyleSheet.create({
    container: {
      marginBottom: spacing.lg,
    },
    checkboxRow: {
      flexDirection: "row",
      alignItems: "center",
    },
    checkbox: {
      width: 24,
      height: 24,
      borderRadius: borderRadius.sm,
      borderWidth: 2,
      borderColor: colors.primary,
      justifyContent: "center",
      alignItems: "center",
      marginRight: spacing.sm,
      backgroundColor: colors.background,
    },
    checkboxChecked: {
      backgroundColor: colors.primary,
    },
    checkmark: {
      color: "#ffffff",
      fontSize: 16,
      fontWeight: "bold",
    },
    label: {
      ...typography.label,
      color: colors.text,
    },
    disabled: {
      opacity: 0.6,
    },
    disabledText: {
      color: colors.textLight,
    },
    error: {
      ...typography.error,
      color: colors.danger,
      marginTop: spacing.xs,
    },
  });

  return (
    <View style={[styles.container, containerStyle]}>
      <TouchableOpacity
        style={[styles.checkboxRow, disabled && styles.disabled]}
        onPress={handlePress}
        activeOpacity={0.7}
      >
        <View style={[styles.checkbox, value && styles.checkboxChecked]}>
          {value && <Text style={styles.checkmark}>✓</Text>}
        </View>
        <Text
          style={[styles.label, labelStyle, disabled && styles.disabledText]}
        >
          {label}
        </Text>
      </TouchableOpacity>
      {error && <Text style={styles.error}>{error}</Text>}
    </View>
  );
};
